<template>
  <div id="app">
    <div class="row">
      <div class="col-12">
        <h2 class="generalTitle">Black list<a href="#" class="float-right" data-toggle="modal" data-target="#addUser">
            <v-icon name="hi-plus" scale="1.2" />Añadir registro
          </a></h2>
      </div>
    </div>
    <div class="row mx-1">
      <div class="col-12 mb-3">
        <list-filters @filter="filter($event)" />
      </div>
      <div class="col-12" v-if="blackList">
        <div class="card" :class="{ 'card-versionMovil': !$store.state.responsive.viewDesktopLists}">
          <div class="card-body pb-0">
            <list :blackList="blackList" @sendRefreshRegisterList="sendRefreshRegisterList($event)" />
          </div>
        </div>
      </div>
      <div class="col-12" v-if="blackList == {}">
        <div class="alert alert-info">No hay resultados para mostrar</div>
      </div>
    </div>
    <AddData :id="'addUser'" :modalTitle="'AÑADIR REGISTROS'" :class="'modal-xl'" :showFooter="false"></AddData>
  </div>
</template>

<script>
import axios from 'axios';
import ListFilters from '../Shared/BlackListFilters.vue';
import AddData from './templates/AddToBlackList.vue';
import List from './templates/List.vue';
export default {
  name: 'BlackList',
  components: {
    ListFilters,
    List,
    AddData
  },
  data() {
    return {
      name: '',
      email: '',
      date: '',
      documentNumber: '',
      street: '',
      number: '',
      surname: '',
      postalCode: '',
      mobile: '',
      blackList: null,
      from: 0,
      to: 0,
      order: '',
      totalItems: 0,
      filters: '',
    }
  },
  methods: {
    filter(value) {
      this.name = value.name !== undefined ? value.name : this.name;
      this.documentNumber = value.documentNumber !== undefined ? value.documentNumber : this.documentNumber;
      this.mobile = value.mobile !== undefined ? value.mobile : this.mobile;
      this.email = value.email !== undefined ? value.email : this.email;
      this.street = value.street !== undefined ? value.street : this.street;
      this.surname = value.surname !== undefined ? value.surname : this.surname;
      this.number = value.number !== undefined ? value.number : this.number;
      this.postalCode = value.postalCode !== undefined ? value.postalCode : this.postalCode;
      this.loadlist();
    },
    selectOrder(value) {
      console.log(value);
      //Rellenar con el order cuando sepamos el formato
    },
    loadlist() {
      this.filters = '';
      if (this.documentNumber !== '' && this.documentNumber !== undefined) {
        this.filters = `legal-identifier/${this.documentNumber}`;
      }
      else if (this.mobile !== '' && this.mobile !== undefined) {
        this.filters = `mobile/${this.mobile}`;
      }
      else if (this.email !== '' && this.email !== undefined) {
        this.filters = `email/${this.email}`;
      }
      else if (this.surname !== '' && this.surname !== undefined) {
        this.filters = `surname/${this.surname}`;
      }
      else if (this.street !== '' && this.street !== undefined && this.number !== '' && this.number !== undefined && this.postalCode !== '' && this.postalCode !== undefined) {
        this.filters = `address/${this.street}/${this.number}/${this.postalCode}`;
      }
      const vm = this;
      if (this.filters != '') {
        axios.get(`/customer/blacklist-${this.filters}`)
          .then((response) => {
            vm.blackList = response.data;
            vm.filters = '';
            console.log(response.data)
          });
      }
      else {
        vm.blackList = null;
      }
    },
    sendRefreshRegisterList(event) {
      const vm = this;
      vm.blackList = event
    },
  },
};
</script>

<style lang="scss"></style>
